import React from 'react';
import { InputLabel, OutlinedInput } from '@mui/material';
import InputMask from 'react-input-mask';
import { FieldError } from '../../../components/form-page-parts';
import { getSupplierDocumentLabel, getSupplierDocumentMask } from './scp-utils';

// CPF/CNPJ com máscara conforme o tipo de fornecedor; estrangeiro aceita texto livre
export function SupplierDocumentInput({ name, supplierType, value, onChange, required, error, labelSuffix }: {
    name: string;
    supplierType?: string | null;
    value?: string | null;
    onChange: (e: any) => void;
    required?: boolean;
    error?: string | false;
    labelSuffix?: string;
}) {
    const mask = getSupplierDocumentMask(supplierType);

    return (
        <React.Fragment>
            <InputLabel required={required}>{getSupplierDocumentLabel(supplierType, labelSuffix)}</InputLabel>
            {mask ? (
                <InputMask mask={mask} name={name} value={value || ''} onChange={onChange}>
                    <OutlinedInput fullWidth name={name} autoComplete="off" error={!!error} />
                </InputMask>
            ) : (
                <OutlinedInput fullWidth name={name} autoComplete="off" value={value || ''} onChange={onChange} error={!!error} />
            )}
            <FieldError message={error} />
        </React.Fragment>
    );
}
